import React from 'react'
import { Header } from './components/Header'
import { HeroSection } from './components/HeroSection'
import { HowItWorks } from './components/HowItWorks'
import { Team } from './components/Team'
import { Footer } from './components/Footer'
import { Unsubscribe } from './components/Unsubscribe'

function App() {
  const path = window.location.pathname

  if (path === '/unsubscribe') {
    return <Unsubscribe />
  }

  return (
    <div className="min-h-screen bg-[#F8F7F4] text-gray-800">
      <Header />
      <main className="w-full">
        <HeroSection />
        <HowItWorks />
        <Team />
      </main>
      <Footer />
    </div>
  )
}

export default App
